import o from"@root/flint.config";import{checkCallback as i}from"@flint/utils";var r,t=null!==(r=i(o))&&void 0!==r?r:{};export{t as config};
